import { Component, Prop, Provide, Vue } from 'vue-property-decorator'
let interval: any = null
@Component
export default class PublishResult extends Vue {
  public secondsToGo = 5

  public countDown() {
    interval = setInterval(() => {
      this.secondsToGo -= 1
      if (this.secondsToGo === 0) {
        clearInterval(interval)
        this.goMyUpload()
      }
    }, 1000)
  }

  public goMyUpload() {
    this.$router.push({ path: '/personal/upload' })
  }

  public mounted() {
    this.countDown()
  }
}
